export const en = {
  myDay: {
    title: "My Day",
    emptyDetails: "Select an activity to view details",
  },
  list: {
    defaultEmptyText: "Select an activity",
    refreshTitle: "Refresh activities",
    refreshAriaLabel: "Refresh activities",
  },
  table: {
    empty: "No activities found",
    selectAllAriaLabel: "Select all activities",
    selectActivityAria: "Select activity {{reference}}",
    unknownCustomer: "Unknown",
    overdueAria: "overdue",
    highValueAria: "high value",
    columns: {
      customer: "Customer",
      reference: "Reference",
      reason: "Reason",
      value: "Value",
      waiting: "Waiting",
      finalStatus: "Final Status",
      remainingSnooze: "Remaining Snooze",
      priority: "Priority",
      assignee: "Assignee",
    },
    outcomeMaybeDone: "Outcome may already be done",
    triggerValueWarning: "Trigger conditions no longer match",
    waitingTooltip: "Waiting {{waiting}} ({{overdue}} past threshold)",
    snoozeUntilTooltip: "Until {{dateTime}}",
  },
  timeline: {
    today: "Today",
    yesterday: "Yesterday",
    justNow: "Just now",
    eventFallback: "Event",
    activityCreated: "Activity created",
    userAddedNote: "{{author}} added a note",
    noteAdded: "Note added",
    assigneeMe: "me",
    assignedToMe: "Assigned to me",
    assignedToSomeone: "Assigned to {{name}}",
    userAssignedTo: "{{author}} assigned to {{name}}",
    assigneeSomeone: "someone",
    userSetNextFollowUp: "{{author}} set next Follow-up",
    userSetNextFollowUpToDate: "{{author}} set next Follow-up to {{date}}",
    nextFollowUp: "Next Follow-up",
    nextFollowUpToDate: "Next Follow-up {{date}}",
    userCompleted: "{{author}} completed this activity",
    completed: "Completed",
    userReopened: "{{author}} reopened this activity",
    reopened: "Reopened",
    userSetOutcome: "{{author}} set outcome to {{outcome}}",
    outcomeSetTo: "Outcome set to {{outcome}}",
    eventCreated: "Created",
    eventNoteAdded: "Note Added",
    eventSnoozed: "Snoozed",
    eventCompleted: "Completed",
    eventReopened: "Reopened",
    eventAssigned: "Assigned",
    eventOutcomeSet: "Outcome Set",
    triggerValueDrifted: "This {{entity}} no longer matches trigger conditions",
    triggerValueRestored: "This {{entity}} matches trigger conditions again",
    userEventLabel: "{{author}} — {{event}}",
    empty: "No activity events yet",
    heading: "Activity",
    nextFollowUpLabel: "Next follow-up:",
    you: "You",
    previousUser: "Previous user",
    deletedLabel: "Removed",
  },
  detail: {
    assignToMe: "Assign to Me",
  },
  items: {
    empty: "No items found",
  },
  notes: {
    openInShopify: "Open in Shopify",
    outcomeHeading: "Outcome",
    noOutcomeSet: "No outcome set",
    reopenNotePlaceholder: "Add a note (optional)...",
    reopenNoteLabel: "Reopen note",
    reopening: "Reopening...",
    reopenActivity: "Reopen Activity",
    addUpdateHeading: "Add Update",
    outcomeLabel: "Outcome:",
    outcomeSelectPlaceholder: "Select...",
    nextFollowUpLabel: "Next follow-up:",
    notePlaceholder: "Add a note...",
    noteLabel: "Add note",
    saveNote: "Save Note",
    saveAndComplete: "Save & Complete",
    saveAndSnooze: "Save & Snooze",
    complete: "Complete",
    snooze: "Snooze",
    noteTab: "Note",
    noteRequired: "Note (required)",
    completing: "Completing...",
    snoozing: "Snoozing...",
    saving: "Saving...",
    completeTask: "Complete task",
    snoozeTask: "Snooze task",
    validation: {
      outcomeRequired: "Select outcome to complete process please",
      followUpRequired: "Select next follow up date to complete process please",
      noteRequired: "Enter note to complete process please",
      reopenRequired: "Note is required to reopen activity",
    },
  },
  filters: {
    clear: "Clear",
    unknownUser: "Unknown",
    unknownTeam: "Unknown",
    assigneePlaceholder: "Assignee",
    searchUsersPlaceholder: "Search users...",
    noUsersFound: "No users found",
    teamPlaceholder: "Team",
    searchTeamsPlaceholder: "Search teams...",
    noTeamsFound: "No teams found",
    preferences: "Preferences",
    rules: "Rules",
    emptyHighValue: "No high-value activities match this view.",
    emptyVIP: "No VIP activities match this view.",
    emptyHighPriority: "No high-priority activities match this view.",
    threholdsHintTxt: "This threshold is managed by your workspace administrator. Contact your administrator if you need it changed.",
    triggersHintTxt: "Priorities are managed in Trigger Rules by your workspace administrator. Contact your administrator if you need them changed.",
    configureIn: "Configure in",
  },
  detailHeader: {
    closeTitle: "Close",
    accessDeniedTitle: "Access Denied",
    accessDeniedMessage:
      "You don't have access to this activity. It belongs to another team.",
    accessDeniedStatus: "Access Restricted",
    accessDeniedHint:
      "If you believe this is an error, contact your workspace administrator.",
    accessDeniedDismiss: "Back to list",
    snoozeUntilTooltip: "Until {{dateTime}}",
    completed: "Completed",
    overdueBy: "Overdue by {{waiting}}",
    waiting: "Waiting {{waiting}}",
    unknownCustomer: "Unknown Customer",
    assignedTo: "Assigned to ",
    unassigned: "Unassigned",
    draftOrderConverted: "Draft Order Converted to Order ",
    checkoutCompleted: "Checkout complete to order ",
    viewDetails: "View Details",
    orderFulfilled: "Order Fulfilled already",
    triggerValueWarning: "This {{entity}} no longer matches trigger conditions",
  },
  overview: {
    overdueAlert: "This activity is overdue and requires attention",
    highValueAlert: "High-value order — prioritize follow-up",
    vipAlert: "VIP customer — prioritize follow-up",
    triggerValueWarning: "This {{entity}} no longer matches the trigger conditions that created this task — its values may have changed.",
    whyAppearedHeading: "Why This Appeared",
    customerHeading: "Customer",
    orderSnapshotHeading: "Order Snapshot",
    fields: {
      name: "Name",
      phone: "Phone",
      shippingPhone: "Shipping Phone",
      email: "Email",
      lifetimeSales: "Lifetime Sales",
      orders: "Orders",
      reference: "Reference",
      total: "Total",
      payment: "Payment",
      items: "Items",
    },
  },
  summary: {
    assignedToYou: "assigned to you",
    highValue: "high-value",
    highPriority: "high priority",
    overdue: "overdue",
    vip: "VIP",
    filterAriaLabel: "Filter activities",
    clearAll: "Clear all",
    removeFilterAriaLabel: "Remove filter",
  },
  pagination: {
    itemLabel: "activities",
  },
  bulk: {
    selectedOne: "{{count}} activity selected",
    selectedMany: "{{count}} activities selected",
    delete: "Delete",
    deleteDialogTitleOne: "Delete {{count}} activity",
    deleteDialogTitleMany: "Delete {{count}} activities",
    deleteDialogDescriptionOne: "This action cannot be undone. {{count}} activity will be permanently deleted along with all associated events.",
    deleteDialogDescriptionMany: "This action cannot be undone. {{count}} activities will be permanently deleted along with all associated events.",
    cancel: "Cancel",
    deleteConfirm: "Delete",
  },
  bulkAssign: {
    assignTo: "Assign to",
    searchPlaceholder: "Search sales reps...",
    noUsersFound: "No users found",
    unknownUser: "Unknown",
    defaultRole: "Rep",
  },
  assign: {
    assign: "Assign",
    searchPlaceholder: "Search users...",
    noUsersFound: "No users found",
    unknownUser: "Unknown",
    defaultRole: "Rep",
  },
  tabs: {
    overview: "Overview",
    items: "Items",
    notes: "Notes",
    orders: "Orders",
  },
  entityTypes: {
    order: "order",
    draft_order: "draft order",
    checkout: "checkout",
  },
  driftReasons: {
    payment_method_not_allowed: "Payment method \"{{actual}}\" is not allowed (expected: {{expected}})",
    order_total_below_min: "Order total {{actual}} is below the {{min}} minimum",
    order_source_not_allowed: "Order source \"{{actual}}\" is not allowed (expected: {{expected}})",
    missing_required_tag: "Missing a required tag (needs one of: {{expected}})",
    has_excluded_tag: "Has an excluded tag: {{tags}}",
    draft_total_below_min: "Draft total {{actual}} is below the {{min}} minimum",
    draft_no_phone: "Draft has no phone number",
    checkout_total_below_min: "Checkout total {{actual}} is below the {{min}} minimum",
    checkout_no_phone: "Customer did not enter a phone number",
    checkout_not_returning: "Customer is not a returning customer",
    checkout_source_not_allowed: "Checkout source \"{{actual}}\" is not allowed (expected: {{expected}})",
    checkout_step_not_reached: "Checkout only reached \"{{actual}}\" (expected one of: {{expected}})",
    customer_required_for_tags: "Customer is required for the configured tag conditions but is missing",
    customer_record_missing: "Customer record is missing for the configured tag conditions",
    missing_required_customer_tag: "Missing a required customer tag (needs one of: {{expected}})",
    has_excluded_customer_tag: "Has an excluded customer tag: {{tags}}",
  },
  paymentMethods: {
    cash_on_delivery: "Cash on Delivery",
    credit_card: "Credit Card",
    paypal: "PayPal",
    bank_transfer: "Bank Transfer",
    manual: "Manual",
    other: "Other",
  },
  reasons: {
    codConfirmation: "{{paymentMethod}} order {{reference}} requires confirmation ({{currency}} {{total}})",
    draftOrder: "Draft order {{reference}} ({{currency}} {{total}})",
    abandonedCheckout: "Abandoned checkout {{reference}} ({{currency}} {{total}})",
  },
  toasts: {
    saveNoteFailed: "Failed to save note. Please try again.",
    snoozeFailed: "Failed to snooze activity. Please try again.",
    completeFailed: "Failed to complete activity. Please try again.",
  },
} as const;
